<template>
  <div class='service-list'>
    <p class='type-list' v-show='jobTypeList.length'>
      <span class='type' :class='{ "active": categoryId === "" }'
            @click.stop='switchType("")'>全部</span>
      <span class='type' v-for='(type, index) in jobTypeList' :key='index' :class='{ "active": categoryId === type.id }'
            @click.stop='switchType(type.id)'>{{type.name}}</span>
    </p>
    <div class='job-list'  v-loading="loading">
      <Job v-for='(job, index) in jobList' :key='index' :job='job'></Job>
    </div>
    <div class='pages main-pagination' v-show='total > condition.pageRows'>
      <el-pagination :page-size="condition.pageRows" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <Nothing  v-if="!jobList.length && !loading"></Nothing>

  </div>
</template>

<script>
import Job from './JobItem';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      jobTypeList: [],
      jobList: [],
      categoryId: '',
      // 当前筛选类型
      condition: {
        currPage: 1,
        pageRows: 10,
      },
      total: 0,
      loading: true,
    };
  },
  methods: {
    // 分页
    handleCurrentChange(page) {
      this.condition.currPage = page;
      this.getJobList();
    },
    getJobTypeListList() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/job/category/list`, {
        parkId: this.currentParkId,
      }).then((response) => {
        this.loading = false;
        const res = response.data;
        if (res.resCode === '10000') {
          this.jobTypeList = res.resData.pageList ? res.resData.pageList : [];
          if (!this.jobTypeList.length) {
            this.nothing = true;
          }
        }
      });
    },
    getJobList() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/job/info/list`, {
        ...this.condition,
        parkId: this.currentParkId,
        categoryId: this.categoryId,
      }).then((response) => {
        this.loading = false;
        const res = response.data;
        if (res.resCode === '10000') {
          this.jobList = res.resData.pageList ? res.resData.pageList : [];
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
    // 类型筛选
    switchType(key) {
      this.categoryId = key;
      this.getJobList();
    },
  },
  components: { Job },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  created() {
    this.getJobTypeListList();
    this.getJobList();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.service-list{
  margin-top: 40px;
  .type-list{
    .type{
      @include line-ellipsis;
      display: inline-block;
      padding: 0 10px;
      width: 100px;
      height: 30px;
      margin-right: 20px;
      border: 1px solid #c4c4c4;
      border-radius: 2px;
      line-height: 30px;
      text-align: center;
      color: #666666;
      cursor: pointer;
      &.active{
        background: $color-main;
        border-color: $color-main;
        color: #ffffff;
      }
    }
    .type:hover{
      background: $color-main;
      border-color: $color-main;
      color: #ffffff;
    }
  }
  .pages{
    margin-top: 30px;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/humanResource/components/child/JobList.vue